import PageHeader from "@/components/PageHeader";
import { FAQS } from "@/data/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";

export default function FAQ() {
    return (
        <>
            <PageHeader
                eyebrow="FAQs"
                title="Straight answers to the most common questions."
                subtitle="Can't find yours? Drop a note via the contact page and we'll add it here."
            />
            <section className="container-editorial pb-24 max-w-3xl">
                <Accordion type="single" collapsible data-testid="faq-page-accordion">
                    {FAQS.map((f, i) => (
                        <AccordionItem key={i} value={`item-${i}`} className="border-stone-300">
                            <AccordionTrigger data-testid={`faq-page-trigger-${i}`} className="text-left font-serif text-xl hover:no-underline">{f.q}</AccordionTrigger>
                            <AccordionContent className="text-stone-700 leading-relaxed">{f.a}</AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
                <div className="mt-14 text-center bg-stone-100 rounded-2xl p-10">
                    <h3 className="font-serif text-2xl">Still stuck?</h3>
                    <p className="text-stone-600 mt-2">We reply to every message.</p>
                    <Link to="/contact" className="inline-block mt-4 rounded-full bg-primary text-primary-foreground px-6 py-3 text-sm font-semibold hover:bg-primary/90">Contact us</Link>
                </div>
            </section>
        </>
    );
}
